<ng-container *ngIf="isContentLoading">
    <div class="d-flex justify-content-center m-5">
      <i class="icon-2x icon-spinner2 spinner text-dark"></i>
    </div>
  </ng-container>